var _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup231(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 46,
    viewBox: "0 0 60 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3338 37.3333L11.0005 32L16.3338 26.6666",
    stroke: "black",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0005 23.9999V26.6665C35.0005 28.081 34.4386 29.4376 33.4384 30.4378C32.4382 31.438 31.0817 31.9999 29.6672 31.9999H11.0005",
    stroke: "black",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.667 7.99988L35.0003 13.3332L29.667 18.6665",
    stroke: "black",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0005 21.3333V18.6666C11.0005 17.2521 11.5624 15.8955 12.5626 14.8953C13.5628 13.8952 14.9193 13.3333 16.3338 13.3333H35.0005",
    stroke: "black",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5005,
    cy: 22.5,
    r: 20.5,
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup231);
export default __webpack_public_path__ + "static/media/Group 23 (1).32dccc0cb6e4d5957104504a278e934a.svg";
export { ForwardRef as ReactComponent };